import styled from "styled-components";
import { Typography, TypographyVariant } from "../../../components/ui-kit";

const Wrapper = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-basis: 25%;
  background: #ffffff;
  border: 1px solid #dbe3eb;
  box-shadow: 0px 4px 30px rgba(194, 206, 219, 0.6);
  border-radius: 10px;
  padding: 30px;
  cursor: pointer;
  text-decoration: none;
  p {
    text-align: center;
  }
`;

const Icon = styled.div`
  margin-bottom: 12px;
`;

interface DirectionCardProps {
  data: {
    icon: JSX.Element;
    iconPartner?: JSX.Element;
    label: string;
    labelPartner?: string;
    link: string;
    customizationEnabled?: boolean;
  };
}

const DirectionCard: React.FunctionComponent<DirectionCardProps> = ({
  data: { icon, iconPartner, label, labelPartner, link, customizationEnabled },
}) => {
  return (
    // <a >
    <Wrapper
      href={customizationEnabled ? undefined : link}
      target="_blank"
      rel="noreferrer"
    >
      <Icon>{customizationEnabled ? iconPartner : icon}</Icon>
      <Typography variant={TypographyVariant.BODY5}>
        {customizationEnabled ? labelPartner : label}
      </Typography>
    </Wrapper>
    // </a>
  );
};

export default DirectionCard;
